export default "__VITE_ASSET__Cm22UnNY__"